export function min (min, number = false) {
  return (value) => {
    if (!value) {
      return true
    }

    if (!number) {
      return value.length >= min || `Минимальное кол-во символов ${min}`
    }

    if (isNumber(value)) {
      return value >= min || `Значение должно быть больше ${min}`
    }

    return 'Значение не является числом'
  }
}

export function max (max, number = false) {
  return (value) => {
    if (!value) {
      return true
    }

    if (!number) {
      return value.length <= max || `Максимальное кол-во символов ${max}`
    }

    if (isNumber(value)) {
      return value <= max || `Значение должно быть меньше ${max}`
    }

    return 'Значение не является числом'
  }
}

export function upperCase () {
  return (value) => {
    if (!value) {
      return true
    }

    return value === value.toUpperCase() || 'Буквы должны быть в верхнем регистре'
  }
}

function isNumber (value) {
  return value && !isNaN(Number(value))
}
